import { sdk } from '@farcaster/miniapp-sdk'
import { supabase } from './lib/supabase'

type Opts = { timeoutMs?: number }
export function addMiniAppOnFirstInteraction({ timeoutMs = 5000 }: Opts = {}) {
  let done = false
  let t: number | undefined

  const finish = () => { events.forEach(ev => window.removeEventListener(ev, on, opts)); clearTimeout(t) }
  const opts: AddEventListenerOptions = { passive: true }
  const events: (keyof WindowEventMap)[] = ['click','pointerdown','keydown','touchstart']

  const showFallback = () => window.dispatchEvent(new CustomEvent('miniapp:add:fallback'))

  const run = async () => {
    if (done) return
    done = true
    try {
      // addMiniApp() retorna void - se não der erro, foi sucesso
      await sdk.actions.addMiniApp()
      
      // Marcar usuário como added no Supabase diretamente
      try {
        const context = await sdk.context
        const fid = context?.user?.fid
        console.log('🔍 DEBUG: Context:', context)
        console.log('🔍 DEBUG: FID:', fid)
        
        if (fid) {
          console.log('🔍 DEBUG: Atualizando Supabase diretamente com FID:', fid)
          
          // Usar configuração existente do Supabase
          // const supabase = await sb() // já temos o singleton
          
          const { data, error } = await supabase
            .from('users')
            .update({ added: true })
            .eq('fid', String(fid))
            .select()
          
          if (error) {
            console.error('🔍 DEBUG: Erro Supabase:', error)
          } else {
            console.log('🔍 DEBUG: Sucesso Supabase:', data)
          }
        } else {
          console.log('🔍 DEBUG: FID não encontrado no context')
        }
      } catch (e) {
        console.error('🔍 DEBUG: Erro ao marcar como added:', e)
        // Silencioso - não afeta o addMiniApp
      }
      
    } catch (error) {
      // Se der erro, mostrar fallback
      showFallback()
    } finally {
      finish()
    }
  }

  const on = () => run()
  events.forEach(ev => window.addEventListener(ev, on, opts))

  // timeout: ninguém interagiu → mostra botão
  t = window.setTimeout(() => { if (!done) { done = true; showFallback(); finish() } }, timeoutMs)

  return finish
}
